<template>
    <div class="root border-box ">
        <div class="right-title flex flex-center-cz padding-left-l">评论</div>
        <vue-custom-scrollbar class="right-body" ref="comment-body" >
            <div class="padding-m flex flex-col  border-box " v-for="item in data">

                <div class="flex flex-space-between">
                    <div class="font-s font-bold">{{item.userName}}</div>
                    <div class="font-s color-gray">{{item.createTime}}</div>
                </div>
                <div v-html="item.content.replace(/\n/g, '<br>')" class="margin-top-s font-s  border-box txt-wrap" >
                </div>
                <div class="flex margin-top-s flex-end  border-box">
                    <div v-if="userId == item.userId" class="flex flex-row margin-right-xl flex-center-cz pointer" @click="del(item.id, item.userName)"><img class="logo-18"
                            src="@/assets/images/hsz3.png" />
                    </div>

                    <div class="flex flex-row margin-right-m flex-center-cz pointer" @click="reply(item.id, item.userName)"><img class="logo-18"
                            src="@/assets/images/pinglun.png" />
                        <div class="margin-left-s font-s">{{item.commentCount}}</div>
                    </div>
                    <div class="flex flex-row margin-right-m flex-center-cz pointer margin-left-m" @click="like(item.id)"><img class="logo-20"
                            src="@/assets/images/dianzan.png" />
                        <div class="margin-left-s font-s">{{item.likeCount}}</div>
                    </div>
                </div>
                <div v-if="item.child.length>0" class="flex flex-col bk-color-rgb-01 margin-s border-radius-ms padding-s font-s">
                    <div v-for="child in item.child"><span>{{child.userName}}</span>：{{child.content}}</div>
                </div>
            </div>

        </vue-custom-scrollbar>


        <div class="right-bottom padding-m">
            <div class=" margin-top-l border border-radius-ms flex flex-col" style="height:85px;background-color: #fff;">
                <textarea ref="content" rows="2" class="border-radius-ms padding-m" placeholder="请输入评论信息"
                    style="border: none;" v-model="content"></textarea>
                <div class="flex flex-space-between font-s pointer">
                    <div v-if="commentId != null" class="margin-left-m flex flex-center-cz">
                        <span class="font-s color-gray">回复{{commentPerson}}:</span>
                        <img class="margin-left-l logo-18" src="@/assets/images/close.png" @click="closeRely" />
                    </div>
                    <div v-if="commentId==null" class="show"></div>
                    <div class="margin-right-m btn-blue-full h25 w60 border-radius-xl" @click="comment" >发布</div>
                </div>
        </div>

        <ScanLogin  :show="showScanLogin" @close="loginClose"></ScanLogin>
        

    </div>
    </div>
</template>

<script>
import {httpPost,httpGet, httpDelete} from "@/utils/httpUtils.js"
import config from '@/config/index.js'
import {debounce,objToStr} from '@/utils/sysUtils.js'
import ScanLogin from '@/modules/scanLogin/ScanLogin.vue'

export default {
    name: 'Comment',
    props:{
        docId:{},
        data:{}
    },
    components:{
        ScanLogin
    },
    data() {
        return {
            showScanLogin: false,
            commentId: null,
            commentPerson: null,
            content: "",
            userId : sessionStorage.getItem("userId")
        }
    },
    methods: {

        like: debounce(
            function(id) {
                console.log("多次点击事件，只执行第一次点击事件");
                let url = config.configData.api_url +   "/business/lzComment/like?id=" + id;
                httpGet(url,{}).then((res) => {
                    console.log(res.data);
                    if (res.data.success == true) {   
                        this.$emit("change");
                    } else {
                        return;           
                    }
                })
            }, 1000, true
        ),
        del(id, createBy) {

            this.$showMsgBox({
                caption:"询问",
                msg: '确定要删除该评论吗？',
                callback:(data) => {
                    if (data == "yes") {
                        this.$showLoading();
                        let url = config.configData.api_url +   "/business/lzComment/delete?id=" + id;
                        httpDelete(url,{}).then((res) => {
                            this.$closeLoading();
                            console.log(res.data);
                            if (res.data.success == true) {   
                                this.$emit("change");
                            } else {
                                return;           
                            }
                        })
                    } 
                }
            })
        },
        reply(id,createBy) {
            this.commentId = id;
            this.commentPerson = createBy;
            console.log(this.$refs['content']);
            this.$nextTick(() => {
                this.$refs['content'].select();
            })
        },
        closeRely() {
            this.commentId = null;
            this.commentPerson = null;

        },
        loginClose() {
           this.token = sessionStorage.getItem("token");
           if (objToStr(this.token) != "") {
              this.userId = sessionStorage.getItem("userId");
              this.userName = this.getUserName();
           } 
           this.showScanLogin = false
        },
        comment: debounce(
            function() {
                console.log("多次点击事件，只执行第一次点击事件");
                let userId = sessionStorage.getItem("userId");
                if (userId == null || userId == "") {
                    this.showScanLogin = true;
                } else {
                    if (this.content == "") {
                        this.$showToast({msg: '请填写评论内容'});
                        return;
                    }
                    let url = config.configData.api_url +   "/business/lzComment/add";
                    let parentId = "0";
                    if (this.commentId  != null) {
                        parentId = this.commentId;
                    }
                    let param = {"docId": this.docId, "parentId": 0, "content": this.content, "parentId": parentId};
                    this.$showLoading();
                    httpPost(url,param).then((res) => {
                        this.$closeLoading();
                        console.log(res.data);
                        if (res.data.success == true) {   
                            this.$emit("change");
                            this.content = "";
                            this.commentId = null;
                            this.commentPerson = ""
                            if (objToStr(res.data.message) != "") {
                                this.$showToast(res.data.message)
                            }
    
                        } else {
                            return false;           
                        }
                    })
                }                
            }, 1000, true
        ),
    }
}
</script>

<style scoped>

    .right-body {
      position: absolute ;
      top: 60px;
      right: 0;
      left:0;
      bottom: 100px;
    }
    .right-bottom {
      position: absolute ;
      right: 0;
      height: 100px;
      left: 0;
      bottom: 0;
      
    }

    .right-title {
        height: 45px;
        border-bottom: 1px solid rgba(0, 0, 0, .1) ;   
    }



</style>


// WEBPACK FOOTER //
// src/modules/comment/Comment.vue